<div class='progress-message__content'>
    <ng-container *ngIf="progress && progress < 100; else spinner">
        <div class="loader">
            <mat-progress-spinner [value]="progress">
            </mat-progress-spinner>
        </div>
        <span class="progress-percent">{{progress}}%</span>
    </ng-container>
    <ng-template #spinner>
        <div class="loader">
            <mat-spinner></mat-spinner>
        </div>
    </ng-template>
    <span class="progress-title">{{title}}</span>
</div>